import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { canAccessRoute, type AppRoutePath } from '../../config/accessControl';

export interface RoleRouteGuardProps {
  children: React.ReactNode;
  /** Route template path used to look up allowed roles */
  routePath: AppRoutePath | string;
}

/**
 * Global (non-facility) role gate. Redirects to /dashboard when the user's
 * role is not allowed for `routePath`.
 */
const RoleRouteGuard: React.FC<RoleRouteGuardProps> = ({ children, routePath }) => {
  const { user } = useAuth();

  if (!canAccessRoute(user?.role, routePath)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default RoleRouteGuard;
